<script>
import Divider from "@/components/atoms/divider";
import LoadingSpinner from "@/components/molecules/loading-spinner";

export default {
  name: "AlerteConfirmationMagasinChargement",
  components: {
    LoadingSpinner,
    Divider
  },
  props: {
    magasinName: {
      type: String,
      required: false,
      default: null
    },
    context: {
      type: String,
      required: false,
      default: 'store-loc'
    }    
  }
};
</script>

<template>
  <div>
    <h2 class="u-font-secondary u-font-24 u-font-700 u-color-primary u-text-center u-mb-xs">
      Changement de magasin
    </h2>
    <div class="u-flex u-flex-justify-center u-flex-align-center u-mt-lg u-mb-lg ">
      <LoadingSpinner
        size="sm"
        inline
        class="u-mr-sm"
      />
      <div class=" u-font-700 u-font-15">
        <template v-if="context === 'store-loc'">
          Redirection vers le magasin {{ magasinName }}
        </template>
        <template v-else>
          Rattachement au magasin {{ magasinName }}
        </template>
      </div>
    </div>
    <Divider dotted />
    <p class="u-font-secondary u-font-24 u-font-700 u-color-primary u-text-center u-mb-sm u-mt-md">
      <template v-if="context === 'store-loc'">
        Votre panier est sauvegardé dans vos listes
      </template>
      <template v-else>
        Si vous avez un panier, il est sauvegardé dans vos listes
      </template>
    </p>
    <p class="u-font-15 u-text-center u-mr-xlg u-ml-xlg u-mb-lg u-pr-xlg u-pl-xlg u-ml-sm@sm u-mr-sm@sm u-pr-sm@sm u-pl-sm@sm">
      Retrouvez votre panier depuis vos listes de courses sous le nom « Panier sauvegardé »
    </p>
  </div>
</template>
